"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFor = exports.audiencesOf = exports.withAudiences = exports.Audiences = exports.Schema = exports.ALL = exports.Audience = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Order = __importStar(require("./order"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Audience';
/**
 * The audiences a group of endpoints is documented for.
 *
 * Each audience corresponds to one of the documents the legacy Unified API
 * serves under `/v2/docs/<audience>` (see `routes/v2/openapi/router.js`).
 * Audience and access key are not one-to-one: `admin`, `user` and `system`
 * have their own `APIDOCS_*` key, but `device` and `fleet` are both gated by
 * `fleetDocsGuard` (`APIDOCS_FLEET_KEY`); no device key exists today. They
 * stay separate audiences here because they are separate documents; serving
 * them behind different credentials needs a key provisioned first, which is
 * a cutover concern, not a modelling one.
 */
exports.Audience = {
    Admin: 'admin',
    User: 'user',
    Device: 'device',
    Fleet: 'fleet',
    System: 'system',
};
/** Stable, sorted list of every audience; drives deterministic document generation. */
exports.ALL = Order.sorted(Object.values(exports.Audience));
exports.Schema = effect_1.Schema.Literal(exports.Audience.Admin, exports.Audience.User, exports.Audience.Device, exports.Audience.Fleet, exports.Audience.System).annotations({
    identifier: `${exports.NAMESPACE}.Schema`,
    description: 'Documentation audience an API group is published to',
});
/**
 * Annotation carried by an `HttpApiGroup` listing the audiences it belongs to.
 *
 * A group without this annotation is only part of the complete document.
 */
class Audiences extends effect_1.Context.Reference()(`${exports.NAMESPACE}.Audiences`, {
    defaultValue: () => [],
}) {
}
exports.Audiences = Audiences;
/** Annotates a group with the audiences it is documented for. */
const withAudiences = (...audiences) => (group) => group.annotate(Audiences, dedupe(audiences));
exports.withAudiences = withAudiences;
/** Reads the audiences a group is annotated with (empty when not annotated). */
const audiencesOf = (group) => effect_1.Context.get(group.annotations, Audiences);
exports.audiencesOf = audiencesOf;
/** Whether a group is documented for the given audience. */
const isFor = (audience) => (group) => (0, exports.audiencesOf)(group).includes(audience);
exports.isFor = isFor;
const dedupe = (audiences) => Order.sorted(new Set(audiences));
//# sourceMappingURL=audience.js.map